import { useInterval } from "@mantine/hooks";
import { useEffect, useEffectEvent } from "react";

import { isVoiceTask, useActiveTask } from "@/sdk";
import { useFeatureFlag } from "@/shared-utils";

const heartbeatIntervalDelay = 60_000;

/**
 * Hook that enables/disables undesired tabs blocking depending on whether or
 * not there is an active voice task.
 *
 * @see https://github.com/asurion-core/expert-tool-restriction
 */
export function useUndesiredTabsCloser() {
    const { data: isEnabled = false } = useFeatureFlag("EWP-isUndesiredTabsCloserEnabled");
    const heartbeatInterval = useInterval(() => window.postMessage({ type: "heartbeat" }, "*"), heartbeatIntervalDelay);

    const onStartBlocking = useEffectEvent(() => {
        window.postMessage({ type: "enableBlocking" }, "*");
        heartbeatInterval.start();
    });
    const onStopBlocking = useEffectEvent(() => {
        window.postMessage({ type: "disableBlocking" }, "*");
        heartbeatInterval.stop();
    });

    // using events instead of `useEffect()` would be more ideal but "sdk_initialized" is emitted
    // before this hook is mounted, we can check the active task instead
    const activeTask = useActiveTask();
    const hasVoiceTask = isVoiceTask(activeTask);
    useEffect(() => {
        if (!isEnabled) return;
        if (hasVoiceTask) onStartBlocking();
        else onStopBlocking();
    }, [isEnabled, hasVoiceTask]);
}
